interface MinimizeIconProps {
  className?: string;
}

export const MinimizeIcon = ({ className = "w-4 h-4" }: MinimizeIconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="16" height="16" rx="3" fill="#8FB4C2" fillOpacity="0.3"/>
      <path d="M3.33334 8H12.6667" stroke="#8FB4C2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
